import { ImportJob } from 'entities/consentImport';
import { Selectors as Router } from 'router';
import { kotlinRestAPIClient } from 'services/apiGatewayClient';
import { State } from 'store';
import { createService } from '../genericAPIGatewayService';
import { Service } from './services';

const client = kotlinRestAPIClient<ImportJob>();
const endpointCreator = (state: State) => {
  const siteId = Router.getSiteId(state);
  return siteId ? `/sites/${siteId}/consent_imports` : undefined;
};

export const { Actions, Selectors, Sagas } = createService<ImportJob, Service.JobBySite>({
  service: Service.JobBySite,
  client,
  endpointCreator,
  stateConverter: (state: State) => state.data.consentImportJobsBySite,
  sagas: ['GET_COLLECTION'],
});
